import api, { cdnApi, HEADERS } from '~config/api';

export const DisabledService = {
  getDisableds: (storeId) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    return api.get(`v1/kds/disableds?store_id=${storeId}`);
  },
  getPrices: (storeId) =>
    api.get(`v1/prices?store_id=${storeId}`, {
      platform: 'web'
    }),
  getStaticMenu: (menuId) => cdnApi.get(`menus/${menuId}.json?nocache=${Date.now()}`),
  // No startDate on purpose: the server sets it. Sent from the browser clock, a block dated
  // even seconds ahead of the server is neither listed nor enforced until that time passes.
  block: ({ id, type, storeId, endDate, show }) => {
    api.setHeader(HEADERS.ADMIN_STORE_ID, storeId);
    return api.post('v1/kds/disableds', {
      disabled: {
        deactivatableId: id,
        deactivatableType: type,
        storeId,
        endDate,
        show
      }
    });
  },
  unBlock: (id) => api.delete(`v1/kds/disableds/${id}`)
};

export default DisabledService;
